import axios from "axios";
import { store } from "../store/app";
import { apiUrl, PORT } from "../environment";
import { parse, stringify } from 'qs'
import { attachDecryptInterceptor } from "../utils/responseCrypto";

const API_BASE_URL = `${apiUrl}${PORT}`;

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: {
    encode: parse,
    serialize: stringify,
  },
});

// Runs first so every interceptor below receives decrypted data.
attachDecryptInterceptor(axiosClient);

// Attach token dynamically from Redux store
axiosClient.interceptors.request.use(
  (config) => {
    const token = store.getState()?.login?.data?.accessToken;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Check if the request data is FormData
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    }



    return config;
  },
  (error) => {
    return Promise.reject(error); // ✅ Ensure return
  }
);

// Global error handling
axiosClient.interceptors.response.use(
  (response) => response?.data,
  (error) => {
    let errorMessage = "Unknown error";

    if (error.response) {
      errorMessage = typeof error.response.data === "object"
        ? JSON.stringify(error.response.data)
        : error.response.data;
    } else {
      errorMessage = error.message || "Network error";
    }

    console.error("API Error:", errorMessage);

    return Promise.reject(errorMessage);
  }
);

export default axiosClient;
